import { CreateIconArguments } from '##/icons/Icon/helpers';

import IconFractureOrangeSizeS from './IconFractureOrange_size_s';

const props: CreateIconArguments = {
  l: IconFractureOrangeSizeS,
  m: IconFractureOrangeSizeS,
  s: IconFractureOrangeSizeS,
  xs: IconFractureOrangeSizeS,
  name: 'IconFractureOrange',
  renderType: { l: 'use', m: 'use', s: 'use', xs: 'use' },
  color: 'multiple',
};

export default props;
